import { IDLE_OPTIONS } from "./sessionSettings";

const LABELS: Record<number, string> = {
  5: "5 minuta (preporučeno)",
  15: "15 minuta",
  30: "30 minuta",
  60: "1 sat",
};

/** Settings → Session: how long a signed-in session stays open without any activity. */
export function SessionSettings({
  idleMinutes,
  onChange,
}: {
  idleMinutes: number;
  onChange: (minutes: number) => void;
}) {
  return (
    <section className="max-w-xl space-y-3" data-testid="session-settings">
      <h2 className="text-lg font-semibold">Sesija</h2>
      <p className="text-sm text-muted-foreground">
        Sesija se zatvara nakon toliko vremena bez aktivnosti. Osvježavanje stranice ne odjavljuje.
      </p>
      <label className="block text-sm">
        <span className="text-xs uppercase tracking-wide text-muted-foreground">Odjava nakon neaktivnosti</span>
        <select
          data-testid="session-idle-select"
          value={String(idleMinutes)}
          onChange={(event) => onChange(Number(event.target.value))}
          className="mt-1 block w-full rounded border border-border bg-background px-3 py-2"
        >
          {IDLE_OPTIONS.map((minutes) => (
            <option key={minutes} value={String(minutes)}>
              {LABELS[minutes]}
            </option>
          ))}
        </select>
      </label>
      {idleMinutes > 5 && (
        <p data-testid="session-idle-warning" className="rounded border border-amber-500/40 bg-amber-500/10 p-3 text-sm">
          Dulje trajanje je prikladno samo na vašem osobnom uređaju, a ne na zajednički korištenom računalu.
        </p>
      )}
    </section>
  );
}
